import { Field } from "@ark-ui/react/field";

import { css, cx } from "../../styled-system/css";

import { inputStyles } from "./input";

export type MultilineInputProperties = Field.TextareaProps & {
  /** 注意のテキスト */
  caution?: string;
  containerClassName?: string;
  containerProperties?: Field.RootProps;
  /** 説明のテキスト */
  description?: string;
  label?: string;
};

export function MultilineInput({
  className,
  caution,
  containerClassName,
  containerProperties,
  description,
  label,
  required,
  ...properties
}: MultilineInputProperties) {
  return (
    <Field.Root
      {...containerProperties}
      className={cx(
        inputStyles({ type: "root" }),
        containerClassName,
        containerProperties?.className,
      )}
      invalid={Boolean(caution)}
      required={required}
    >
      <Field.Label className={inputStyles({ type: "label" })}>{label}</Field.Label>
      <Field.Textarea
        autoresize
        className={cx(
          "peer",
          css(inputStyles.raw({ type: "frame" }), inputStyles.raw({ type: "input" })),
          className,
        )}
        {...properties}
      />
      <Field.HelperText
        className={cx(
          css(inputStyles.raw({ type: "helperText" }), Boolean(caution) && { display: "none" }),
        )}
      >
        {description}
      </Field.HelperText>
      <Field.ErrorText
        className={cx(
          inputStyles({ type: "errorText" }),
          caution ? css({ display: "block" }) : css({ display: "none" }),
        )}
      >
        {caution}
      </Field.ErrorText>
    </Field.Root>
  );
}
